// プロダクト追加時はここに1行追加すること（キーと値は同名にする）。
// 対応するsrc/<プロダクト名>/main.tsxを追加すること
// src/<プロダクト名>/routes/にルートツリーを作成すること（例: src/freshers/routes/__root.tsx, src/freshers/routes/index.tsx）。
// 上記により、プロダクト名はそのままURLプレフィックス（例: /freshers）とエントリの置き場所（例: src/freshers/main.tsx）になる。
// eMBAだけは例外的にルート直下で配信されるため、どのプロダクト名にも一致しないURLはeMBAが受け持つ
// （エントリも従来どおりsrc直下のmain.tsxのまま）。
export const PRODUCTS = {
  emba: 'emba',
  freshers: 'freshers',
} as const;

export type Product = (typeof PRODUCTS)[keyof typeof PRODUCTS];

export const detectProductNameFromPath = (pathname: string): Product =>
  Object.values(PRODUCTS).find(
    // 「/プロダクト名ちょうど」か「/プロダクト名/で始まる」場合に配下と判定する。
    (product) =>
      pathname === `/${product}` || pathname.startsWith(`/${product}/`),
  ) ?? PRODUCTS.emba;
